const SubmissionStatusComponent = {
    templateUrl: '/component/status/submissionStatus.tpl.html',
    controller: 'submissionStatusController',
    bindings: {}
};

angular.module('gw-um-submission')
    .component('submissionStatus', SubmissionStatusComponent);
